import {
  Component,
  ChangeDetectionStrategy,
} from '@angular/core';


@Component({
  selector: 'sb-card',
  templateUrl: './sb-card.component.html',
  styleUrls: ['./sb-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbCardComponent {}
